import { Column } from "./IndexTable";

export const insertIf = <T>(condition: any, ...elements: Column<T>[]) =>
  condition ? elements : [];
